"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        card: {
            marginBottom: theme.spacing(1),
        },
        cardContent: {
            display: 'flex',
            alignItems: 'center',
        },
        icon: {
            paddingRight: "".concat(theme.spacing(2), "px"),
        },
    });
});
